import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import momentLocalizer from 'react-widgets-moment';
import adicionarFiltro from '../../actions/empresa/adicionarFiltroEmpresa'
import removerFiltro from '../../actions/empresa/removerFiltroEmpresa'
import FiltroBusca from '../comum/FiltroBusca'
import 'react-widgets/dist/css/react-widgets.css';

momentLocalizer();

export class FiltroBuscaEmpresa extends Component {
  render () {
    if (!this.props.filtrosAdicionados) {
      return <div>Carregando...</div>
    }
    return (
      <FiltroBusca
        filtrosAdicionados={this.props.filtrosAdicionados}
        filtro={this.props.filtro}
        opcoes={this.props.opcoes}
        isRadio={this.props.isRadio}
        isNumero={this.props.isNumero}
        isFiltroData={this.props.isFiltroData}
        adicionarFiltro={this.props.adicionarFiltro}
        removerFiltro={this.props.removerFiltro}
      />
    )
  }
}

export const mapStateToProps = state => ({
  filtrosAdicionados: state.filtrosAdicionadosEmpresas
})

export const mapDispatchToProps = dispatch => (
  bindActionCreators({
    adicionarFiltro,
    removerFiltro,
  }, dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(FiltroBuscaEmpresa)
